(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
(function () {
  var drawer = document.getElementById('cart-drawer');
  if (!drawer || drawer.dataset.cdInit) return;
  drawer.dataset.cdInit = '1';
  var backdrop = document.querySelector('.cart-drawer-backdrop');
  var itemsEl = drawer.querySelector('[data-cart-items]');
  var emptyEl = drawer.querySelector('[data-cart-empty]');
  var summaryEl = drawer.querySelector('[data-cart-summary]');
  var subtotalEl = drawer.querySelector('[data-cart-subtotal]');
  var shippingEl = drawer.querySelector('[data-cart-shipping]');
  var totalEl = drawer.querySelector('[data-cart-total]');
  var shipEl = drawer.querySelector('[data-cart-ship]');
  var shipTextEl = drawer.querySelector('[data-cart-ship-text]');
  var shipBarEl = drawer.querySelector('[data-cart-ship-bar]');
  var shipFillEl = drawer.querySelector('[data-cart-ship-fill]');
  var errorEl = drawer.querySelector('[data-cart-error]');
  var discountLineEl = drawer.querySelector('[data-cart-discount-line]');
  var discountEl = drawer.querySelector('[data-cart-discount]');
  var promoInputEl = drawer.querySelector('[data-cart-promo-input]');
  var promoApplyEl = drawer.querySelector('[data-cart-promo-apply]');
  var promoErrorEl = drawer.querySelector('[data-cart-promo-error]');
  var promoTagsEl = drawer.querySelector('[data-cart-promo-tags]');
  var upsellEl = drawer.querySelector('[data-cart-upsell]');
  var thresholdCents = (parseFloat(drawer.dataset.freeShipThreshold) || 0) * 100;
  var upsellHideInCart = drawer.dataset.upsellHideIncart === 'true';
  var AUTO_CODE = (drawer.getAttribute('data-auto-discount') || '').trim();
  var autoBusy = false;
  var SHIP_CALC_HTML = '<span class="cart-drawer__ship-calc">Calculée à l\'étape suivante</span>';
  var CHECK_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
  var seqCounter = 0, lastApplied = 0, lastCart = null, lastAddedKey = null;
  var currency = drawer.dataset.currency || 'EUR';
  var locale = document.documentElement.lang || 'fr-FR';

  function money(cents) {
    var loc = currency === 'EUR' ? 'fr-FR' : (currency === 'USD' ? 'en-US' : locale);
    try { return new Intl.NumberFormat(loc, { style: 'currency', currency: currency }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2) + ' ' + currency; }
  }
  function escapeHtml(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function sizedImage(url, w) { if (!url) return ''; try { var u = new URL(url, window.location.origin); u.searchParams.set('width', w); return u.href; } catch (e) { return url; } }

  function updateCounts(n) {
    document.querySelectorAll('[data-cart-count], .lch__cartcount, .header__cart-count').forEach(function (el) { el.textContent = n; });
  }
  function showError(m) { if (errorEl) { errorEl.textContent = m; errorEl.hidden = false; } }
  function clearError() { if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; } }

  var chain = Promise.resolve();
  function enqueue(task) { var run = chain.then(task, task); chain = run.catch(function () {}); return run; }
  var timers = {}, pending = {};

  function renderShipping(totalCents, count) {
    if (!shipEl) return;
    if (!thresholdCents || count === 0) { shipEl.hidden = true; return; }
    shipEl.hidden = false;
    var pct = Math.min(100, Math.round(totalCents * 100 / thresholdCents));
    var remaining = thresholdCents - totalCents;
    if (remaining > 0) { shipEl.classList.remove('is-done'); shipTextEl.innerHTML = 'Plus que <strong>' + money(remaining) + '</strong> pour la livraison offerte'; }
    else { shipEl.classList.add('is-done'); shipTextEl.innerHTML = '<span class="cart-drawer__ship-badge">' + CHECK_SVG + '<span>Livraison offerte débloquée</span></span>'; }
    if (shipBarEl) shipBarEl.setAttribute('aria-valuenow', pct);
    if (shipFillEl) shipFillEl.style.width = pct + '%';
  }

  function syncUpsell(cart) {
    if (!upsellEl) return;
    var ids = {}; ((cart && cart.items) || []).forEach(function (i) { ids[i.product_id] = true; });
    var cards = upsellEl.querySelectorAll('[data-upsell-product]');
    var visible = 0;
    cards.forEach(function (c) {
      var inCart = !!ids[c.getAttribute('data-upsell-product')];
      var hide = upsellHideInCart && inCart;
      c.hidden = hide;
      if (!hide) visible++;
    });
    upsellEl.hidden = (visible === 0) || !cart || cart.item_count === 0;
  }

  function render(cart) {
    if (!cart) return;
    currency = cart.currency || currency;
    itemsEl.innerHTML = '';
    if (cart.item_count === 0) {
      emptyEl.style.display = 'flex'; summaryEl.hidden = true;
      if (shipEl) shipEl.hidden = true;
      syncUpsell(cart); lastAddedKey = null; return;
    }
    emptyEl.style.display = 'none'; summaryEl.hidden = false;
    renderShipping(cart.total_price, cart.item_count);
    cart.items.forEach(function (item) {
      var variant = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<p class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</p>' : '';
      var row = document.createElement('div');
      row.className = 'cart-drawer__item';
      row.dataset.key = item.key; row.dataset.unit = item.final_price;
      if (lastAddedKey && item.key === lastAddedKey) row.classList.add('is-new');
      row.innerHTML =
        '<a class="cart-drawer__item-thumb" href="' + escapeHtml(item.url) + '">' +
          (item.image ? '<img src="' + escapeHtml(sizedImage(item.image, 160)) + '" alt="" width="76" height="76" loading="lazy">' : '') +
        '</a>' +
        '<div class="cart-drawer__item-meta">' +
          '<div class="cart-drawer__item-head">' +
            '<p class="cart-drawer__item-title">' + escapeHtml(item.product_title) + '</p>' +
            '<button type="button" class="cart-drawer__item-x" data-qty-remove data-key="' + escapeHtml(item.key) + '" aria-label="Retirer">' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
            '</button>' +
          '</div>' + variant +
          '<div class="cart-drawer__item-bottom">' +
            '<div class="cart-drawer__qty">' +
              '<button type="button" data-qty-down data-key="' + escapeHtml(item.key) + '" aria-label="Diminuer">−</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-qty-up data-key="' + escapeHtml(item.key) + '" aria-label="Augmenter">+</button>' +
            '</div>' +
            '<span class="cart-drawer__item-price">' + money(item.final_line_price) + '</span>' +
          '</div>' +
        '</div>';
      itemsEl.appendChild(row);
    });
    lastAddedKey = null;
    subtotalEl.textContent = money(cart.items_subtotal_price);
    if (thresholdCents && cart.total_price >= thresholdCents) { shippingEl.innerHTML = '<span class="is-free">Offerte</span>'; }
    else { shippingEl.innerHTML = SHIP_CALC_HTML; }
    renderDiscounts(cart);
    totalEl.textContent = money(cart.total_price);
    syncUpsell(cart);
  }

  function renderDiscounts(cart) {
    var codes = (cart.discount_codes || []).filter(function (d) { return d && d.applicable; });
    var totalDisc = cart.total_discount || 0;
    if (promoTagsEl) {
      promoTagsEl.innerHTML = codes.map(function (d) {
        var amt = (d.amount && d.amount > 0) ? d.amount : (codes.length === 1 ? totalDisc : 0);
        var amtHtml = amt > 0 ? '<span class="cart-drawer__promo-amount">−' + money(amt) + '</span>' : '';
        return '<span class="cart-drawer__promo-tag"><span class="cart-drawer__promo-code">' + escapeHtml(d.code) + '</span>' + amtHtml +
          '<button type="button" class="cart-drawer__promo-remove" data-cart-promo-remove="' + escapeHtml(d.code) + '" aria-label="Retirer le code ' + escapeHtml(d.code) + '">×</button></span>';
      }).join('');
    }
    if (discountLineEl) {
      if (cart.total_discount > 0) { discountLineEl.hidden = false; if (discountEl) discountEl.textContent = '−' + money(cart.total_discount); }
      else { discountLineEl.hidden = true; }
    }
  }

  function applyCart(cart, seq) {
    if (!cart) return;
    if (seq < lastApplied) return;
    lastApplied = seq; lastCart = cart;
    render(cart); updateCounts(cart.item_count);
  }
  function refresh() {
    var seq = ++seqCounter;
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        applyCart(cart, seq);
        var p = maybeAutoApply(cart);
        return p ? p.then(function () { return lastCart || cart; }) : cart;
      })
      .catch(function () {});
  }

  function open(skip) {
    clearError();
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false');
    if (backdrop) backdrop.hidden = false;
    document.body.style.overflow = 'hidden';
    if (!skip) refresh();
  }
  function close() {
    drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true');
    if (backdrop) backdrop.hidden = true;
    document.body.style.overflow = '';
  }

  function recomputeTotals() {
    var rows = itemsEl.querySelectorAll('.cart-drawer__item');
    var subtotal = 0, count = 0;
    rows.forEach(function (r) {
      var q = parseInt(r.querySelector('.cart-drawer__qty span').textContent, 10) || 0;
      var unit = parseInt(r.dataset.unit, 10) || 0;
      subtotal += q * unit; count += q;
    });
    if (count === 0) {
      emptyEl.style.display = 'flex'; summaryEl.hidden = true;
      if (shipEl) shipEl.hidden = true;
      if (upsellEl) upsellEl.hidden = true;
    } else {
      subtotalEl.textContent = money(subtotal);
      if (!lastCart || !(lastCart.total_discount > 0)) { totalEl.textContent = money(subtotal); }
      if (thresholdCents && subtotal >= thresholdCents) { shippingEl.innerHTML = '<span class="is-free">Offerte</span>'; }
      else { shippingEl.innerHTML = SHIP_CALC_HTML; }
      renderShipping(subtotal, count);
    }
    updateCounts(count);
  }

  function currentCodes() {
    if (!lastCart || !lastCart.discount_codes) return [];
    return lastCart.discount_codes.filter(function (d) { return d && d.applicable; }).map(function (d) { return d.code; });
  }
  function promoBusy(on) { if (!promoApplyEl) return; if (on) promoApplyEl.classList.add('is-busy'); else promoApplyEl.classList.remove('is-busy'); }
  function showPromoError(m) { if (promoErrorEl) { promoErrorEl.textContent = m; promoErrorEl.hidden = false; } }
  function clearPromoError() { if (promoErrorEl) { promoErrorEl.hidden = true; promoErrorEl.textContent = ''; } }
  function updateDiscounts(codes) {
    return enqueue(function () {
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ discount: codes.join(',') }) }).then(function (r) { return r.json(); });
    });
  }
  function applyPromo(raw) {
    var code = (raw || '').trim(); if (!code) return;
    clearPromoError(); promoBusy(true);
    var keep = currentCodes(); var next = keep.slice();
    if (!next.some(function (c) { return c.toLowerCase() === code.toLowerCase(); })) next.push(code);
    updateDiscounts(next).then(function (cart) {
      var entry = (cart.discount_codes || []).filter(function (d) { return d.code && d.code.toLowerCase() === code.toLowerCase(); })[0];
      if (!entry || !entry.applicable) {
        showPromoError('Code invalide ou non applicable.');
        return updateDiscounts(keep).then(function (c) { applyCart(c, ++seqCounter); });
      }
      if (promoInputEl) promoInputEl.value = '';
      applyCart(cart, ++seqCounter);
    }).catch(function () { showPromoError('Oups, réessaie dans un instant.'); }).then(function () { promoBusy(false); });
  }
  function removePromo(code) {
    var next = currentCodes().filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); });
    clearPromoError();
    if (AUTO_CODE && code.toLowerCase() === AUTO_CODE.toLowerCase()) rememberOptOut();
    updateDiscounts(next).then(function (cart) { applyCart(cart, ++seqCounter); }).catch(function () { return refresh(); });
  }

  /* ---------- Code promo automatique ----------
     Le diagnostic, les pages produit et la buybar ajoutent au panier via
     /cart/add.js et ne posent jamais de code. Sans ce bloc, un client qui passe
     par le diagnostic arrive au checkout plein tarif alors que la promo est
     annoncee partout. On pose donc le code du reglage sur tout panier non vide
     qui n'en porte aucun, quel que soit le chemin d'ajout.
     Le code se change dans l'editeur de theme, une seule case, sans deploiement.

     Quatre garde-fous :
     1. On ne touche jamais a un panier qui porte deja un code applicable, quel
        qu'il soit. Shopify n'accepte qu'un seul code de commande : ecraser
        celui que le client a tape lui-meme serait pire que le bug d'origine.
     2. Un code faux, expire ou non applicable a ce panier est retire en
        silence et l'etat d'avant est restaure. Aucun message d'erreur, le
        client n'a rien demande.
     3. Un seul appel a la fois. Deux ouvertures de tiroir rapprochees ne
        peuvent pas declencher deux applications concurrentes.
     4. Si le client retire le code a la main, on ne le lui repose pas de la
        session. */
  var OPTOUT_KEY = 'lccPromoOptOut';

  function optedOut() {
    if (!AUTO_CODE) return false;
    try { return sessionStorage.getItem(OPTOUT_KEY) === AUTO_CODE.toLowerCase(); }
    catch (e) { return false; }
  }
  function rememberOptOut() {
    try { sessionStorage.setItem(OPTOUT_KEY, AUTO_CODE.toLowerCase()); } catch (e) {}
  }
  function hasAnyCode(cart) {
    return (cart.discount_codes || []).some(function (d) { return d && d.applicable; });
  }
  function maybeAutoApply(cart) {
    if (!AUTO_CODE || autoBusy) return null;
    if (!cart || !cart.item_count) return null;
    if (hasAnyCode(cart) || optedOut()) return null;
    autoBusy = true;
    return updateDiscounts([AUTO_CODE]).then(function (next) {
      if (hasAnyCode(next)) { applyCart(next, ++seqCounter); return next; }
      return updateDiscounts([]).then(function (back) { applyCart(back, ++seqCounter); return back; });
    }).catch(function () {}).then(function (out) { autoBusy = false; return out; });
  }

  function changeQty(key, qty) {
    clearError();
    var row = itemsEl.querySelector('[data-key="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]');
    if (row) {
      if (qty <= 0) { row.parentNode.removeChild(row); }
      else {
        var span = row.querySelector('.cart-drawer__qty span');
        var unit = parseInt(row.dataset.unit, 10) || 0;
        var pr = row.querySelector('.cart-drawer__item-price');
        if (pr) pr.textContent = money(unit * qty);
        if (span) span.textContent = qty;
      }
    }
    recomputeTotals();
    pending[key] = qty;
    if (timers[key]) clearTimeout(timers[key]);
    timers[key] = setTimeout(function () {
      delete timers[key];
      var target = pending[key]; delete pending[key];
      enqueue(function () {
        return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: target }) })
          .then(function (r) { return r.json(); })
          .then(function (cart) { updateCounts(cart.item_count); if (Object.keys(timers).length === 0) applyCart(cart, ++seqCounter); })
          .catch(function () { return refresh(); });
      });
    }, 300);
  }

  window.LaClinicCart = { open: open, close: close, refresh: refresh };
  refresh();

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.matches('[data-cart-promo-form]')) { e.preventDefault(); applyPromo(promoInputEl ? promoInputEl.value : ''); return; }
    if (!form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    e.stopPropagation();
    var btn = form.querySelector('[type="submit"], [name="add"]');
    if (btn) { btn.classList.add('is-adding'); btn.disabled = true; }
    open(true);
    enqueue(function () {
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (r) { if (r.ok) return r.json(); return r.json().then(function (err) { throw err; }); })
        .then(function (item) { lastAddedKey = item.key || null; return refresh(); })
        .catch(function (err) { if (err && err.description) { showError(err.description); return refresh(); } form.submit(); })
        .finally(function () { if (btn) { btn.classList.remove('is-adding'); btn.disabled = false; } });
    });
  }, true);

  document.addEventListener('click', function (e) {
    var openEl = e.target.closest('[data-cart-open]');
    if (openEl) { e.preventDefault(); open(); return; }
    var closeEl = e.target.closest('[data-cart-close]');
    if (closeEl && !closeEl.href) { e.preventDefault(); }
    if (closeEl) { close(); return; }
    var pr = e.target.closest('[data-cart-promo-remove]');
    if (pr) { e.preventDefault(); removePromo(pr.getAttribute('data-cart-promo-remove')); return; }
    var rm = e.target.closest('[data-qty-remove]');
    if (rm) { changeQty(rm.dataset.key, 0); return; }
    var dn = e.target.closest('[data-qty-down]');
    if (dn) { var s1 = dn.parentElement.querySelector('span'); changeQty(dn.dataset.key, Math.max(0, parseInt(s1.textContent, 10) - 1)); return; }
    var up = e.target.closest('[data-qty-up]');
    if (up) { var s2 = up.parentElement.querySelector('span'); changeQty(up.dataset.key, parseInt(s2.textContent, 10) + 1); return; }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });

  try {
    if (/[?&]cart=open(&|$)/.test(window.location.search)) {
      open();
      if (window.history && history.replaceState) { history.replaceState(null, '', window.location.pathname); }
    }
  } catch (e) {}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-laclinic"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__lchHeaderInit) return;
  window.__lchHeaderInit = true;

  function closeSearch() {
    document.querySelectorAll('[data-lch-search].is-open').forEach(function (b) { b.classList.remove('is-open'); });
  }
  function closeContact() {
    document.querySelectorAll('[data-lchc-pop]').forEach(function (p) { p.setAttribute('hidden', ''); });
    document.querySelectorAll('[data-lchc-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }

  document.addEventListener('click', function (e) {
    var search = e.target.closest && e.target.closest('[data-lch-search-toggle]');
    if (search) {
      var box = search.closest('[data-lch-search]');
      var willOpen = !box.classList.contains('is-open');
      closeSearch(); closeContact();
      if (willOpen) {
        box.classList.add('is-open');
        var inp = box.querySelector('input[type="search"]');
        if (inp) { setTimeout(function () { inp.focus(); }, 60); }
      }
      return;
    }

    var contact = e.target.closest && e.target.closest('[data-lchc-toggle]');
    if (contact) {
      var wrap = contact.closest('[data-lchc]');
      var pop = wrap.querySelector('[data-lchc-pop]');
      var open = pop.hasAttribute('hidden');
      closeContact(); closeSearch();
      if (open) { pop.removeAttribute('hidden'); contact.setAttribute('aria-expanded', 'true'); }
      return;
    }

    if (!(e.target.closest && e.target.closest('[data-lch-search]'))) closeSearch();
    if (!(e.target.closest && e.target.closest('[data-lchc]'))) closeContact();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeSearch(); closeContact(); }
  });
})();

(function () {
  if (window.__lchStickyInit) return;
  window.__lchStickyInit = true;
  function init() {
    document.querySelectorAll('.lch[data-lch-sticky]').forEach(function (header) {
      if (header.__lchSticky) return;
      var mode = header.getAttribute('data-lch-sticky');
      if (mode !== 'always' && mode !== 'smart') return;
      header.__lchSticky = true;
      var spacer = document.createElement('div');
      spacer.setAttribute('aria-hidden', 'true');
      spacer.style.height = '0px';
      header.parentNode.insertBefore(spacer, header.nextSibling);
      var lastY = window.pageYOffset || 0;
      var fixed = false;
      var homeTop = 0;
      function measureHome() { if (!fixed) { homeTop = header.getBoundingClientRect().top + (window.pageYOffset || 0); } }
      function onScroll() {
        if (header.classList.contains('is-menu-open')) { lastY = window.pageYOffset || 0; return; }
        var y = window.pageYOffset || 0;
        if (y > homeTop + 1) {
          if (!fixed) { fixed = true; header.classList.add('lch--fixed'); spacer.style.height = header.offsetHeight + 'px'; }
          if (mode === 'smart') {
            if (y > lastY + 5) header.classList.add('lch--up');
            else if (y < lastY - 5) header.classList.remove('lch--up');
          }
        } else if (fixed) {
          fixed = false; header.classList.remove('lch--fixed', 'lch--up'); spacer.style.height = '0px';
        }
        lastY = y;
      }
      measureHome();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function () { measureHome(); if (fixed) spacer.style.height = header.offsetHeight + 'px'; });
      onScroll();
    });
  }
  if (document.readyState !== 'loading') { init(); } else { document.addEventListener('DOMContentLoaded', init); }
})();

(function () {
  if (window.__lchMobileInit) return;
  window.__lchMobileInit = true;
  function hdr(el) { return el && el.closest ? el.closest('.lch') : null; }
  function closeMenu(h) {
    if (!h) return;
    h.classList.remove('is-menu-open');
    document.documentElement.style.overflow = '';
    var t = h.querySelector('[data-lch-menu-toggle]');
    if (t) t.setAttribute('aria-expanded', 'false');
  }
  document.addEventListener('click', function (e) {
    var tg = e.target.closest && e.target.closest('[data-lch-menu-toggle]');
    if (tg) {
      var h = hdr(tg); if (!h) return;
      var open = h.classList.toggle('is-menu-open');
      if (open) h.classList.remove('lch--up');
      tg.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.style.overflow = open ? 'hidden' : '';
      return;
    }
    var cl = e.target.closest && e.target.closest('[data-lch-menu-close]');
    if (cl) { closeMenu(hdr(cl)); return; }
    var ms = e.target.closest && e.target.closest('[data-lch-msearch-toggle]');
    if (ms) {
      var h2 = hdr(ms); if (!h2) return;
      var o = h2.classList.toggle('is-msearch-open');
      if (o) { var inp = h2.querySelector('.lch__msearch input'); if (inp) { setTimeout(function () { inp.focus(); }, 60); } }
      return;
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { document.querySelectorAll('.lch.is-menu-open').forEach(function (h) { closeMenu(h); }); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["produits-selection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRoot(root) {
      if (root.dataset.fpsReady) return;
      root.dataset.fpsReady = '1';

      var track = root.querySelector('[data-fps-track]');

      // Flèches mobile/tablette : défile d'une carte.
      var arrows = root.querySelectorAll('[data-fps-arrow]');
      for (var a = 0; a < arrows.length; a++) {
        (function (arr) {
          arr.addEventListener('click', function () {
            if (!track) return;
            var card = track.querySelector('[data-fps-card]');
            var gap = parseInt(getComputedStyle(track).columnGap || getComputedStyle(track).gap, 10) || 20;
            var w = card ? card.getBoundingClientRect().width : 280;
            track.scrollBy({ left: (arr.getAttribute('data-fps-arrow') === 'next' ? 1 : -1) * (w + gap), behavior: 'smooth' });
          });
        })(arrows[a]);
      }
      // Place les flèches au centre de l'image.
      function setArrowTop() {
        var img = root.querySelector('.fps__media');
        if (img && img.clientHeight) root.style.setProperty('--fps-arrow-top', (img.clientHeight / 2) + 'px');
      }
      // Flèches intelligentes : masque la flèche gauche tant qu'on n'a pas scrollé.
      function updateArrows() {
        if (!track) return;
        var prev = root.querySelector('[data-fps-arrow="prev"]');
        var next = root.querySelector('[data-fps-arrow="next"]');
        var max = track.scrollWidth - track.clientWidth;
        var x = track.scrollLeft;
        if (prev) prev.classList.toggle('is-active', x > 5);
        if (next) next.classList.toggle('is-active', x < max - 5);
      }
      setArrowTop();
      updateArrows();
      if (track) track.addEventListener('scroll', function () { window.requestAnimationFrame(updateArrows); });
      var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { setArrowTop(); updateArrows(); }, 150); });
      window.addEventListener('load', function () { setArrowTop(); updateArrows(); });
      setTimeout(function () { setArrowTop(); updateArrows(); }, 500);

      // Pastilles de variante : change l'image + la variante du bouton + le prix.
      var swatches = root.querySelectorAll('[data-fps-swatch]');
      for (var i = 0; i < swatches.length; i++) {
        (function (sw) {
          sw.addEventListener('click', function () {
            var card = sw.closest('[data-fps-card]');
            if (!card) return;
            var sibs = card.querySelectorAll('[data-fps-swatch]');
            for (var k = 0; k < sibs.length; k++) sibs[k].classList.remove('is-active');
            sw.classList.add('is-active');

            var img = card.querySelector('[data-fps-img]');
            if (img && sw.getAttribute('data-img')) { img.removeAttribute('srcset'); img.src = sw.getAttribute('data-img'); }
            var add = card.querySelector('[data-fps-add]');
            if (add) add.setAttribute('data-fps-variant', sw.getAttribute('data-vid'));

            var priceEl = card.querySelector('[data-fps-price]');
            if (priceEl && sw.getAttribute('data-price')) priceEl.innerHTML = sw.getAttribute('data-price');
            var cmpEl = card.querySelector('[data-fps-compare]');
            if (cmpEl) {
              var c = sw.getAttribute('data-compare');
              if (c) { cmpEl.innerHTML = c; cmpEl.removeAttribute('hidden'); }
              else { cmpEl.setAttribute('hidden', ''); }
            }
          });
        })(swatches[i]);
      }

      // Bouton « Ajouter au panier »
      var adds = root.querySelectorAll('[data-fps-add]');
      for (var j = 0; j < adds.length; j++) {
        (function (btn) {
          btn.addEventListener('click', function () {
            if (btn.disabled) return;
            var action = btn.getAttribute('data-fps-action');
            var url = btn.getAttribute('data-fps-url');
            var id = btn.getAttribute('data-fps-variant');
            var available = btn.getAttribute('data-available') === 'true';

            if (action === 'product' || !id || !available) { if (url) window.location.href = url; return; }

            var hasDrawer = window.LaClinicCart && typeof window.LaClinicCart.open === 'function';
            // Action « aller au panier » SANS tiroir installe : comportement classique (page panier).
            if (action === 'cart' && !hasDrawer) {
              var f = document.createElement('form');
              f.method = 'post'; f.action = '/cart/add';
              f.innerHTML = '<input type="hidden" name="id" value="' + id + '"><input type="hidden" name="quantity" value="1">';
              document.body.appendChild(f); f.submit();
              return;
            }
            // Sinon (tiroir present, ou action « reste sur la page ») : ajout AJAX + ouverture du tiroir.
            btn.disabled = true;
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: parseInt(id, 10), quantity: 1 })
            }).then(function (r) { return r.json(); })
              .then(function () {
                flash(btn);
                document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true }));
                if (hasDrawer) { window.LaClinicCart.open(); }
                else if (action === 'cart') { window.location.href = '/cart'; }
              })
              .catch(function () { if (url) window.location.href = url; })
              .then(function () { setTimeout(function () { btn.disabled = false; }, 200); });
          });
        })(adds[j]);
      }

      function flash(btn) {
        var added = btn.getAttribute('data-added');
        if (!added) return;
        var lbl = btn.querySelector('[data-fps-label]') || btn;
        var base = btn.getAttribute('data-label') || lbl.textContent;
        lbl.textContent = added;
        setTimeout(function () { lbl.textContent = base; }, 1600);
      }
    }

    function initAll() {
      var roots = document.querySelectorAll('[data-fps-root]');
      for (var i = 0; i < roots.length; i++) initRoot(roots[i]);
    }
    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(sec) {
    if (sec.dataset.arevReady) return;
    sec.dataset.arevReady = '1';
    if (sec.getAttribute('data-layout') !== 'carousel') return;
    var track = sec.querySelector('[data-arev-track]');
    if (!track) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    var items = Array.prototype.slice.call(track.children);
    if (!items.length || reduce) return;
    items.forEach(function (c) {
      var cl = c.cloneNode(true);
      cl.setAttribute('aria-hidden', 'true');
      track.appendChild(cl);
    });
    var hold = function () { track.classList.add('is-held'); };
    var release = function () { track.classList.remove('is-held'); };
    track.addEventListener('pointerdown', hold);
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) {
      track.addEventListener(ev, release);
    });
  }
  function run() {
    document.querySelectorAll('.arev[data-layout="carousel"]').forEach(init);
  }
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["routine-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  function root(el) { return el.closest('[data-rc]'); }

  function initGalleries(scope) {
    (scope || document).querySelectorAll('[data-rc-media]').forEach(function (media) {
      if (media._rcInit) return; media._rcInit = true;
      var track = media.querySelector('[data-rc-media-track]');
      if (!track) return;
      var n = track.children.length;
      var bar = media.parentNode.querySelector('[data-rc-bar]');
      var thumb = bar ? bar.querySelector('[data-rc-thumb]') : null;

      if (bar && thumb && n > 1) {
        thumb.style.width = (100 / n) + '%';
        var update = function () {
          var max = track.scrollWidth - track.clientWidth;
          var p = max > 0 ? track.scrollLeft / max : 0;
          thumb.style.left = (p * (100 - 100 / n)) + '%';
        };
        track.addEventListener('scroll', function () { window.requestAnimationFrame(update); });
        update();
        var bdrag = false;
        var bjump = function (clientX) {
          var r = bar.getBoundingClientRect();
          var ratio = Math.min(Math.max((clientX - r.left) / r.width, 0), 1);
          track.scrollLeft = ratio * (track.scrollWidth - track.clientWidth);
        };
        bar.addEventListener('pointerdown', function (e) { bdrag = true; try { bar.setPointerCapture(e.pointerId); } catch (x) {} bjump(e.clientX); });
        bar.addEventListener('pointermove', function (e) { if (bdrag) bjump(e.clientX); });
        bar.addEventListener('pointerup', function () { bdrag = false; });
        bar.addEventListener('pointercancel', function () { bdrag = false; });
      } else if (bar) {
        bar.style.display = 'none';
      }

      if (n > 1) {
        /* Glisser l'image à la souris (PC) ; le tactile utilise le défilement natif */
        var down = false, moved = false, startX = 0, startLeft = 0;
        track.addEventListener('pointerdown', function (e) {
          if (e.pointerType === 'touch') return;
          down = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft;
          track.classList.add('rc-grabbing');
          try { track.setPointerCapture(e.pointerId); } catch (x) {}
        });
        track.addEventListener('pointermove', function (e) {
          if (!down) return;
          var dx = e.clientX - startX;
          if (Math.abs(dx) > 4) moved = true;
          track.scrollLeft = startLeft - dx;
        });
        var end = function () { down = false; track.classList.remove('rc-grabbing'); };
        track.addEventListener('pointerup', end);
        track.addEventListener('pointercancel', end);
        track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); } }, true);

        /* 2e image au survol (ordinateur) */
        if (media.hasAttribute('data-rc-hover')) {
          var go = function (idx) {
            var slide = track.children[idx];
            if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
          };
          media.addEventListener('mouseenter', function () { if (!down) go(1); });
          media.addEventListener('mouseleave', function () { if (!down) go(0); });
        }
      }
    });
  }

  function setArrowTop(scope) {
    (scope || document).querySelectorAll('[data-rc]').forEach(function (r) {
      var vp = r.querySelector('.rc__viewport');
      var img = r.querySelector('.rc-card__img');
      if (vp && img && img.clientHeight) vp.style.setProperty('--rc-arrow-top', (img.clientHeight / 2) + 'px');
    });
  }

  function initAll(scope) { initGalleries(scope); setArrowTop(scope); }

  if (document.readyState !== 'loading') { initAll(document); } else { document.addEventListener('DOMContentLoaded', function () { initAll(document); }); }
  window.addEventListener('load', function () { setArrowTop(document); });
  var rT; window.addEventListener('resize', function () { clearTimeout(rT); rT = setTimeout(function () { setArrowTop(document); }, 150); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  document.addEventListener('click', function (e) {
    var atc = e.target.closest('[data-rc-atc]');
    if (atc) { e.preventDefault(); addToCart(atc); return; }
    var arrow = e.target.closest('[data-rc-arrow]');
    if (arrow) {
      var r = root(arrow); if (!r) return;
      var track = r.querySelector('[data-rc-track]'); if (!track) return;
      var card = track.querySelector('.rc-card');
      var gap = parseInt(getComputedStyle(track).columnGap || getComputedStyle(track).gap, 10) || 24;
      var w = card ? card.getBoundingClientRect().width : 280;
      track.scrollBy({ left: (arrow.getAttribute('data-rc-arrow') === 'next' ? 1 : -1) * (w + gap), behavior: 'smooth' });
    }
  });

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-rc-variant]');
    if (!sel) return;
    var card = sel.closest('.rc-card'); if (!card) return;
    var opt = sel.options[sel.selectedIndex];
    var price = card.querySelector('[data-rc-price]');
    if (price && opt.getAttribute('data-price')) price.textContent = opt.getAttribute('data-price');
    var btn = card.querySelector('[data-rc-atc]');
    if (btn) {
      btn.setAttribute('data-id', opt.value);
      if (opt.disabled) { btn.setAttribute('disabled', ''); } else { btn.removeAttribute('disabled'); }
    }
  });

  function addToCart(btn) {
    var id = btn.getAttribute('data-id');
    if (!id || btn.hasAttribute('disabled')) return;
    var r = root(btn);
    var behavior = (r && r.getAttribute('data-rc-cart')) || 'toast';
    var routes = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    btn.classList.add('is-loading');
    fetch(routes + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (res) { if (!res.ok) { throw new Error('add failed'); } return res.json(); })
      .then(function () {
        btn.classList.remove('is-loading');
        if (behavior === 'cart') { window.location.href = routes + 'cart'; return; }
        showToast(r);
        refreshCart(routes);
      })
      .catch(function () { btn.classList.remove('is-loading'); window.location.href = routes + 'cart'; });
  }

  function showToast(r) {
    if (!r) return;
    var t = r.querySelector('[data-rc-toast]'); if (!t) return;
    t.classList.add('is-on');
    clearTimeout(r._rcToast);
    r._rcToast = setTimeout(function () { t.classList.remove('is-on'); }, 2200);
  }

  function refreshCart(routes) {
    fetch(routes + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count-bubble, [data-cart-count], .cart-count, .header__cart-count, cart-count').forEach(function (el) {
          var node = el.querySelector('span') || el;
          node.textContent = cart.item_count;
        });
        ['cart:refresh', 'cart:updated', 'cart:change'].forEach(function (name) {
          document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { cart: cart } }));
        });
      })
      .catch(function () {});
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stories-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  function player(root) { return root.querySelector('[data-sb-player]'); }
  function cards(root) { return Array.prototype.slice.call(root.querySelectorAll('[data-sb-card]')); }

  function buildBars(root) {
    var st = root._sb, dlg = player(root);
    var wrap = dlg.querySelector('[data-sb-bars]');
    wrap.innerHTML = '';
    for (var i = 0; i < st.videos.length; i++) {
      var bar = document.createElement('span'); bar.className = 'sb-bar';
      bar.appendChild(document.createElement('i'));
      wrap.appendChild(bar);
    }
    st.bars = Array.prototype.slice.call(wrap.querySelectorAll('.sb-bar'));
  }

  function setBars(root) {
    var st = root._sb; if (!st.bars) return;
    st.bars.forEach(function (bar, i) {
      var fill = bar.firstElementChild; if (fill) fill.style.transform = 'scaleX(' + (i < st.clip ? 1 : 0) + ')';
    });
  }

  function playClip(root) {
    var st = root._sb, dlg = player(root);
    var video = dlg.querySelector('[data-sb-video]');
    video.pause();
    video.setAttribute('src', st.videos[st.clip] || '');
    video.currentTime = 0;
    video.play().catch(function () {});
    var t = dlg.querySelector('[data-sb-title]'); if (t) t.textContent = st.title || '';
    var av = dlg.querySelector('[data-sb-avatar]');
    if (av) { if (st.poster) { av.src = st.poster; av.style.display = ''; } else { av.style.display = 'none'; } }
    setBars(root);
  }

  function loadGroup(root, cardIndex, clipIndex) {
    var st = root._sb, cs = st.cards;
    cardIndex = (cardIndex + cs.length) % cs.length;
    st.card = cardIndex;
    var card = cs[cardIndex];
    st.videos = (card.getAttribute('data-sb-videos') || '').split('|').filter(Boolean);
    st.title = card.getAttribute('data-sb-title') || '';
    st.poster = card.getAttribute('data-sb-poster') || '';
    st.clip = clipIndex;
    if (st.clip >= st.videos.length) st.clip = st.videos.length - 1;
    if (st.clip < 0) st.clip = 0;
    buildBars(root);
    playClip(root);
  }

  function clipStep(root, dir) {
    var st = root._sb; var next = st.clip + dir;
    if (next < 0) { loadGroup(root, st.card - 1, 99); return; }
    if (next >= st.videos.length) { loadGroup(root, st.card + 1, 0); return; }
    st.clip = next; playClip(root);
  }

  function groupStep(root, dir) { loadGroup(root, root._sb.card + dir, 0); }

  function bind(root) {
    var dlg = player(root); if (!dlg || dlg._sbBound) return; dlg._sbBound = true;
    var video = dlg.querySelector('[data-sb-video]');
    dlg.addEventListener('close', function () { video.pause(); video.removeAttribute('src'); video.load(); });
    video.addEventListener('ended', function () { clipStep(root, 1); });
    video.addEventListener('click', function () { if (video.paused) { video.play().catch(function () {}); } else { video.pause(); } });
    video.addEventListener('timeupdate', function () {
      var st = root._sb; if (!st || !st.bars || !video.duration) return;
      var bar = st.bars[st.clip]; if (!bar) return;
      var fill = bar.firstElementChild; if (fill) fill.style.transform = 'scaleX(' + Math.min(video.currentTime / video.duration, 1) + ')';
    });
  }

  function open(root, cardIndex) {
    var dlg = player(root); if (!dlg) return;
    root._sb = { cards: cards(root) };
    bind(root);
    if (typeof dlg.showModal === 'function') { dlg.showModal(); } else { dlg.setAttribute('open', ''); }
    loadGroup(root, cardIndex, 0);
  }

  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-sb-card]');
    if (card) { var root = card.closest('[data-sb]'); if (root) open(root, cards(root).indexOf(card)); return; }
    var nav = e.target.closest('[data-sb-nav]');
    if (nav) {
      var r = nav.closest('[data-sb]'); if (!r || !r._sb) return;
      var v = nav.getAttribute('data-sb-nav');
      if (v === 'clip:1') clipStep(r, 1);
      else if (v === 'clip:-1') clipStep(r, -1);
      else if (v === 'group:1') groupStep(r, 1);
      else if (v === 'group:-1') groupStep(r, -1);
      return;
    }
    var c = e.target.closest('[data-sb-close]');
    if (c) { var d = c.closest('dialog'); if (d) d.close(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tuiles-collections"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRoot(root) {
      if (root.dataset.tccReady) return;
      root.dataset.tccReady = '1';
      var track = root.querySelector('[data-tcc-track]');
      if (!track) return;

      var arrows = root.querySelectorAll('[data-tcc-arrow]');
      for (var a = 0; a < arrows.length; a++) {
        (function (arr) {
          arr.addEventListener('click', function () {
            var card = track.querySelector('[data-tcc-card]');
            var gap = parseInt(getComputedStyle(track).columnGap || getComputedStyle(track).gap, 10) || 8;
            var w = card ? card.getBoundingClientRect().width : 280;
            track.scrollBy({ left: (arr.getAttribute('data-tcc-arrow') === 'next' ? 1 : -1) * (w + gap), behavior: 'smooth' });
          });
        })(arrows[a]);
      }

      function setArrowTop() {
        var media = root.querySelector('.tcc__media');
        if (media && media.clientHeight) root.style.setProperty('--tcc-arrow-top', (media.clientHeight / 2) + 'px');
      }
      function updateArrows() {
        var prev = root.querySelector('[data-tcc-arrow="prev"]');
        var next = root.querySelector('[data-tcc-arrow="next"]');
        var max = track.scrollWidth - track.clientWidth;
        var x = track.scrollLeft;
        if (prev) prev.classList.toggle('is-active', x > 5);
        if (next) next.classList.toggle('is-active', x < max - 5);
      }
      setArrowTop();
      updateArrows();
      track.addEventListener('scroll', function () { window.requestAnimationFrame(updateArrows); });
      var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { setArrowTop(); updateArrows(); }, 150); });
      window.addEventListener('load', function () { setArrowTop(); updateArrows(); });
      setTimeout(function () { setArrowTop(); updateArrows(); }, 500);
    }

    function initAll() {
      var roots = document.querySelectorAll('[data-tcc-root]');
      for (var i = 0; i < roots.length; i++) initRoot(roots[i]);
    }
    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
